module.exports = __webpack_public_path__ + "img/voice-icon.8b39be3e.svg";